import React from 'react';

export const icons = {
    search: (
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="1186 11 26 26"><defs><clipPath id="a"><rect className="a" width="26" height="26" transform="translate(307 88)"/></clipPath></defs><g className="b" transform="translate(879 -77)"><g transform="translate(307 88)"><path className="c" d="M25.772,24.674l-6.318-6.318a11.095,11.095,0,1,0-1.1,1.1l6.318,6.318a.783.783,0,0,0,.548.231.759.759,0,0,0,.548-.231A.779.779,0,0,0,25.772,24.674ZM1.554,11.086a9.529,9.529,0,1,1,9.529,9.535A9.54,9.54,0,0,1,1.554,11.086Z"/></g></g></svg>
    ),
    delete: (
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="-2284.728 -6140.728 25.456 25.456"><defs><clipPath id="a"><rect className="a" width="18" height="18" transform="translate(516 99)"/></clipPath></defs><g className="b" transform="translate(-2566.864 -6575.599) rotate(45)"><g transform="translate(516 99)"><path d="M14.25,9.75H9.75v4.5H8.25V9.75H3.75V8.25h4.5V3.75h1.5v4.5h4.5Z"/></g></g></svg>
    )
};

const Icon = (props) => <a className={`${props.className ? props.className : ''}`} href="#">{icons[props.name]}</a>;

export default Icon;


// WEBPACK FOOTER //
// ./src/components/Icon.jsx